import React, { useLayoutEffect, useRef } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const RaceBarChart = ({ data }) => {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    if (chartRef.current) {
      chartRef.current.dispose();
    }

    let chart = am4core.create('racebarchart', am4charts.XYChart3D);
    chartRef.current = chart;

    chart.paddingBottom = 30;
    chart.angle = 35;

    chart.logo.disabled = true;

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'year';
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.labels.template.disabled = false; 
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.numberFormatter.numberFormat = '#'; 

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;

    const createSeries = (field, name, color) => {
      let series = chart.series.push(new am4charts.ColumnSeries3D());
      series.dataFields.valueY = field;
      series.dataFields.categoryX = 'year';
      series.name = name;
      series.stacked = true;
      series.columns.template.tooltipText = '[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}%';
      series.columns.template.fill = color;
      series.columns.template.stroke = color;
      
      let valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = '{valueY}%';
      valueLabel.label.fill = am4core.color('#FFFFFF');
      valueLabel.label.fontSize = 12; 
      valueLabel.locationY = 0.5;
    };

    createSeries('black', 'Black', am4core.color('#7CB9E8'));
    createSeries('white', 'White', am4core.color('#FF69B4'));
    createSeries('indian', 'Indian', am4core.color('#FFA500'));
    createSeries('coloured', 'Coloured', am4core.color('#800080'));

    chart.legend = new am4charts.Legend();

    return () => {
      chart.dispose();
      chartRef.current = null;
    };
  }, []);

  useLayoutEffect(() => {
    if (chartRef.current) {
      chartRef.current.data = data;
    }
  }, [data]);

  return <div id="racebarchart" style={{ width: '100%', height: '500px' }}></div>;
};

export default RaceBarChart;
